import { useState } from 'react';
import {
  OpenOrderStoreProvider,
  OpenOrderStore,
} from '../../../view/authenticated/organizer/open-shop-orders/OpenOrdersStore';
import {
  PickUpStoreProvider,
  PickUpStore,
} from '../../../view/authenticated/participant/shop/components/PickUp/PickUpStore';
import { ParticipantDetailUI } from './ParticipantDetailUI';

export const ParticipantDetail = () => {
  // A new store on every render would re-trigger every effect that depends on
  // it (e.g. AcceptedUserInfoUI's dispensary/THC fetch), duplicating requests.
  const [pickUpStore] = useState(() => new PickUpStore());
  const [openOrderStore] = useState(() => new OpenOrderStore());

  return (
    <PickUpStoreProvider store={pickUpStore}>
      <OpenOrderStoreProvider store={openOrderStore}>
        <ParticipantDetailUI />
      </OpenOrderStoreProvider>
    </PickUpStoreProvider>
  );
};
